// extracted by mini-css-extract-plugin
export var numpadContainer = "_id-1";
export var phoneButton = "_id-0";